export default function($) {
  jQuery(document).ready(function($) {

    function refresh_cart_ui_from_session() {
      $.ajax({
        type: "GET",
        url: client_configuration.click_and_collect_cart_get_url,
        success: function(response){
          var response_data = JSON.parse( response )
          refresh_cart_ui(
            response_data.cart_new_total_quantity,
            response_data.cart_new_total_amount_formatted
          )
        },
      });
    }

    function refresh_cart_ui(total_qty, total_amount_formatted) {
      $('.js-click-and-collect-mini-cart-qty').html(total_qty)
      $('.js-click-and-collect-mini-cart-price').html(total_amount_formatted)
    }

    function refresh_ui_after_add_to_cart(data, qty_input) {
      if(data.success) {
        refresh_cart_ui(
          data.cart_new_total_quantity,
          data.cart_new_total_amount_formatted
        )

        qty_input.val(0)
        qty_input.removeClass('form-error')
        qty_input.siblings('.js-cc-variation_quantity--error').remove()
      } else {
        qty_input.addClass('form-error')
        qty_input.siblings('.js-cc-variation_quantity--error').remove()
        qty_input.after("<div class='js-cc-variation_quantity--error form-validation-error mt-1.5'>"+data.error+"</div>")
      }
    }

    // START -- Update cc mini cart from session (to handle cache)
    if($('.js-click-and-collect-mini-cart-wrapper').length > 0){
      refresh_cart_ui_from_session()
    }
    // STOP -- Update cc mini cart from session (to handle cache)

    // START -- Add to cart behavior
    if($('.js-cc-variations-wrapper').length > 0){
      $('.js-cc-variation-add-to-cart').click(function(event){
        event.preventDefault()

        var variation_id = $(this).data('variation-id')
        var row_wrapper = $(this).closest('tr')
        var qty_input = row_wrapper.find('.js-cc-variation_quantity_selector')
        var quantity = qty_input.val()

        $.ajax({
          type: "POST",
          url: client_configuration.click_and_collect_cart_add_url,
          data: {
            'variation_id': variation_id,
            'quantity': quantity,
          },
          success: function(response){
            var response_data = JSON.parse( response )
            refresh_ui_after_add_to_cart( response_data, qty_input )
          },
        });
      });
    }
    // STOP -- Add to cart behavior

  });
}
